
import { FaqEntry } from "@/api/dtos/FaqEntry.schema";
import { Component, Vue } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import EditFrame from "../EditFrame.vue";
import * as faqApi from "@/api/faq";
import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";

@Component({
  components: {
    EditFrame,
    DangerButton,
    AddButton,
    CancelButton,
  },
})
export default class Faq extends Vue {
  dialog = false;
  questionToAdd = "";
  answerToAdd = "";
  isAllowedToAdd = false;

  fullDialog: boolean = false;
  fullDialogText: string = "";

  openFull(type: "question" | "answer", item: any) {
    this.fullDialogText = type === "question" ? item.question : item.answer;
    this.fullDialog = true;
  }

  readonly headers: {
    text: string;
    value: keyof FaqEntry | "actions";
    align?: "start" | "center" | "end";
  }[] = [
    { text: "Frage", value: "question", align: "start" },
    { text: "Antwort", value: "answer", align: "start" },
    {
      text: "",
      value: "actions",
      align: "end",
    },
  ];

  faqEntries: FaqEntry[] = [];

  async fetchEntries(): Promise<void> {
    const data = (this.faqEntries = await faqApi.getFaq());

    // sort by ID descending
    // data.sort((a: FaqEntry, b: FaqEntry) => b.id - a.id);

    // sort by ID ascending
    data.sort((a: FaqEntry, b: FaqEntry) => a.id - b.id);
  }

  async onAdd(): Promise<void> {
    try {
      this.dialog = false;
      await faqApi.createFaq({
        question: this.questionToAdd,
        answer: this.answerToAdd,
      } as FaqEntry);
      (this.$refs.addForm as any).resetValidation();
      this.questionToAdd = "";
      this.answerToAdd = "";
      this.isAllowedToAdd = false;

      showToast({
        type: "success",
        message: "Frage erfolgreich hinzugefügt",
      });

      this.fetchEntries();
    } catch (error: any) {
      console.error("Failed to add FAQ:", error);
      showToast({
        response: getAxiosResponse(error),
        message: "Frage konnte nicht hinzugefügt werden",
        type: "error",
      });
    }
  }

  async onDelete(entryId: number): Promise<void> {
    try {
      await faqApi.deleteFaq(entryId);
      showToast({
        message: "Eintrag erfolgreich gelöscht",
        type: "success",
      });
      this.fetchEntries();
    } catch (error: any) {
      showToast({
        response: getAxiosResponse(error),
        message: "Eintrag konnte nicht gelöscht werden",
      });
    }
  }

  mounted(): void {
    this.fetchEntries();
  }
}
